import { Directive, Input, ComponentRef, ComponentFactoryResolver, ViewContainerRef, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormConfigInstance } from '../services/form.service';
import { FieldConfig } from '../models/form-field.model';
import { FormInjectField } from '../components/form-inject/form-inject.model';
import { CleanSubscriptions } from 'src/app/core/classes/clean-subcriptions';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[gioFormInject]'
})
export class FormInjectDirective implements OnInit, OnDestroy {

  @Input() service: FormConfigInstance;
  @Input() field: FieldConfig;
  @Input() group: FormGroup;

  componentRef: ComponentRef<any>;

  _subscriptions: Subscription[] = [];

  set subscribe(v: Subscription) {
    this._subscriptions.push(v);
  }
  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef
  ) { }

  ngOnInit() {
    const field: FormInjectField<any> = this.field as FormInjectField<any>;

    const factory = this.resolver.resolveComponentFactory(field.component);
    this.componentRef = this.container.createComponent(factory);

    if (field.inputs) {
      const keys = Object.keys(field.inputs);
      if (keys && keys.length > 0) {
        keys.forEach(key => {
          this.componentRef.instance[key] = field.inputs[key];
        });
      }
    }

    if (field.outputs) {
      const keys = Object.keys(field.outputs);
      if (keys && keys.length > 0) {
        keys.forEach(key => {
          const emitter: EventEmitter<any> = this.componentRef.instance[key];
          this.subscribe = emitter.subscribe((...params) => {
            field.outputs[key]({ service: this.service }, ...params);
          });

        });
      }
    }

    if (field.onLoadComponent) {
      field.onLoadComponent(this.componentRef.instance);
    }

  }

  ngOnDestroy() {
    this._subscriptions.forEach(s => s.unsubscribe());
  }

}
